import { getWizardConfig } from "@/config/wizardConfig";
import { LegalDocumentType } from "@/store/legalDocumentsApiSlice";

export const LEGAL_DOCUMENT_CONFIG = {
  "terms-of-service": {
    title: "Terms of Use",
    endpoint: "terms-of-service" as const,
  },
  "privacy-policy": {
    title: "Privacy Policy",
    endpoint: "privacy-policy" as const,
  },
} as const;

// Modal configuration for cleaner rendering
export const LEGAL_MODAL_CONFIG: Array<{
  modalKey: "termsOfUse" | "privacyPolicy";
  documentType: LegalDocumentType;
}> = [
  {
    modalKey: "termsOfUse" as const,
    documentType: "terms-of-service" as const,
  },
  {
    modalKey: "privacyPolicy" as const,
    documentType: "privacy-policy" as const,
  },
];

export type LegalDocumentConfig = typeof LEGAL_DOCUMENT_CONFIG;

// User benefit data initial state
export const INITIAL_USER_DATA = {
  FirstName: "",
  MiddleName: "",
  LastName: "",
  DateOfBirth: "",
  Telephone: "",
  EmailAddress: "",
  EmployeeSalary: "",
  EmployerMaxContribution: "",
  VestingScheduleName: "",
  BenefitContributionLimit: "",
  BenefitPlanStartDate: "",
} as const;

// Modal state initial state
export const INITIAL_MODAL_STATE = {
  info: false,
  faqs: false,
  termsOfUse: false,
  privacyPolicy: false,
} as const;

// Age validation — read at call time so the loaded config is always used
export const getMinimumAge = () => getWizardConfig().eligibility.minimumAge;
